import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// pages/ComingSoon.tsx
export default function ComingSoon() {
    return (_jsxs("div", { style: { padding: 40 }, children: [_jsx("h2", { children: "\uD83D\uDEA7 Page Under Construction" }), _jsx("p", { children: "This feature is cooking. Check back soon." })] }));
}
